import { z } from 'zod'
import { UserGender } from '@/core/domain/resources/enums/UserGender.ts'

/**
 * Représentation d'un genre d'utilisateur avec UserGender.Values.UNSPECIFIED par défaut
 */
export const UserGenderSchema = z
  .nativeEnum(UserGender.Values)
  .default(UserGender.Values.UNSPECIFIED)
export type UserGenderEntity = z.infer<typeof UserGenderSchema>

export const UserGenderListSchema = z
  .array(UserGenderSchema)
  .refine(
    (value) => value.length > 0 && new Set(value).size === value.length,
    'Au moins un genre est requis'
  )
export type UserGenderListEntity = z.infer<typeof UserGenderListSchema>